/* eslint-disable jsx-a11y/anchor-has-content */
/* 图素链接无可读文本子节点，可访问名由 aria-label/title 提供，本文件统一豁免该规则 */
import './index.less';
import * as React from 'react';
import cx from 'classnames';
import { OFFICIAL_SITE_URL } from '@src/constants/urls';

const styles = require('./index.less');

/**
 * 通用顶部受控视觉壳：背景+icon、slogan 与「进入官网」外链按钮。
 * 自带 PSD 几何（752x112 @ top:0 left:-1），挂在 750x1650 页面根下；
 * 嵌入偏移画布时由 owner 通过 className 覆盖定位。
 */
const MoCommonTop = ({ className }) => (
  <div className={cx(styles.group1, className)} data-name="通用顶部">
    <div className={styles.layer1} data-name="背景" />
    <div className={styles.layer4} data-name="icon" />
    <div className={styles.layer2} data-name="slogan" />
    {/* 图素按钮无文字，aria-label/title 提供可访问名 */}
    <a
      className={styles.layer3}
      data-name="进入官网-按钮"
      href={OFFICIAL_SITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="进入官网"
      title="进入官网"
    />
  </div>
);

export default React.memo(MoCommonTop);
